var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66536 6.66671H11.6654L14.9987 3.33337H24.9987L28.332 6.66671H33.332C34.2161 6.66671 35.0639 7.0179 35.6891 7.64302C36.3142 8.26814 36.6654 9.11599 36.6654 10V30C36.6654 30.8841 36.3142 31.7319 35.6891 32.3571C35.0639 32.9822 34.2161 33.3334 33.332 33.3334H6.66536C5.78131 33.3334 4.93346 32.9822 4.30834 32.3571C3.68322 31.7319 3.33203 30.8841 3.33203 30V10C3.33203 9.11599 3.68322 8.26814 4.30834 7.64302C4.93346 7.0179 5.78131 6.66671 6.66536 6.66671ZM19.9987 11.6667C17.7886 11.6667 15.6689 12.5447 14.1061 14.1075C12.5433 15.6703 11.6654 17.7899 11.6654 20C11.6654 22.2102 12.5433 24.3298 14.1061 25.8926C15.6689 27.4554 17.7886 28.3334 19.9987 28.3334C22.2088 28.3334 24.3285 27.4554 25.8913 25.8926C27.4541 24.3298 28.332 22.2102 28.332 20C28.332 17.7899 27.4541 15.6703 25.8913 14.1075C24.3285 12.5447 22.2088 11.6667 19.9987 11.6667ZM19.9987 15C21.3248 15 22.5965 15.5268 23.5342 16.4645C24.4719 17.4022 24.9987 18.674 24.9987 20C24.9987 21.3261 24.4719 22.5979 23.5342 23.5356C22.5965 24.4733 21.3248 25 19.9987 25C18.6726 25 17.4008 24.4733 16.4632 23.5356C15.5255 22.5979 14.9987 21.3261 14.9987 20C14.9987 18.674 15.5255 17.4022 16.4632 16.4645C17.4008 15.5268 18.6726 15 19.9987 15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.321ad694ed0d86bce4e66a6668c92b2b.svg";
export { ForwardRef as ReactComponent };